var map = {
	"./en/hotel.json": 115,
	"./ja/hotel.json": 116,
	"./ko/hotel.json": 117,
	"./zh-CN/hotel.json": 118,
	"./zh-TW/hotel.json": 119
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 613;


//////////////////
// WEBPACK FOOTER
// ./public/locales ^\.\/.*\/hotel\.json$
// module id = 613
// module chunks = 80 88